import React from "react";
import { Drawer } from "antd";
import SC from "./style";
import { CloseOutlined } from "@mui/icons-material";

const CustomTitle = ({ title, titleStyle }) => {
  if (title === false) return null;
  return <div style={titleStyle}>{title}</div>;
};

const DetailDrawer = (props) => {
  const {
    open = false,
    onClose = () => {},
    width = "fit-content",
    placement = "right",
    closable = false,
    children,
    title,
    zIndex = 2000,
    style,
    titleStyle,
    headerStyle,
  } = props;

  return (
    <>
      {SC.Globalstyles}
      <Drawer
        width={width}
        placement={placement}
        onClose={closable ? onClose : () => {}}
        closable={false}
        styles={{
          header: headerStyle || { padding: "0px 10px 0px 20px" },
        }}
        title={<CustomTitle title={title} titleStyle={titleStyle} />}
        open={open}
        extra={
          title ? (
            <CloseOutlined
              sx={{ cursor: "pointer", fontSize: "20px", marginTop: "8px" }}
              onClick={onClose}
            >
              Cancel
            </CloseOutlined>
          ) : null
        }
        zIndex={zIndex}
        style={{ ...style }}
      >
        <div>{children}</div>
      </Drawer>
    </>
  );
};
export default DetailDrawer;
